module.exports = __webpack_public_path__ + "img/27.2f9e2fdb.png";